export default "__VITE_ASSET__BdFtu91r__"